import { render, staticRenderFns } from "./CgViewer.vue?vue&type=template&id=44387fec&"
import script from "./CgViewer.vue?vue&type=script&lang=js&"
export * from "./CgViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports